import React, { useState } from "react";
import { Modal, Button } from "rsuite";

interface ModalConfirmData {
  title?: string;
  message: string | JSX.Element;
  onConfirm?: () => any;
  onCancel?: () => any;
}

interface ModalMessageData {
  title?: string;
  message: string | JSX.Element;
  onConfirm?: () => any;
}

const ModalsData = {
  confirm: (data: ModalConfirmData) => {},
  message: (data: ModalMessageData) => {},
};

const ModalsProvider: React.FC<any> = ({ roles, children }) => {
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [modalConfirm, setModalConfirm] = useState<ModalConfirmData>({
    message: "",
  });
  const [modalMessage, setModalMessage] = useState<ModalConfirmData>({
    message: "",
  });

  ModalsData.confirm = (data: ModalConfirmData) => {
    setModalConfirm(data);
    setShowModalConfirm(true);
  };
  ModalsData.message = (data: ModalMessageData) => {
    setModalMessage(data);
    setShowModalMessage(true);
  };

  const onCancelModalConfirm = () => {
    if (modalConfirm.onCancel != null) modalConfirm.onCancel();
    setShowModalConfirm(false);
  };

  const onConfirmModalConfirm = () => {
    if (modalConfirm.onConfirm != null) modalConfirm.onConfirm();
    setShowModalConfirm(false);
  };

  //   const onConfirmModalMessage = () => {
  //     if (modalMessage.onConfirm != null) modalMessage.onConfirm();
  //     setShowModalConfirm(false);
  //   };

  return (
    <>
      <Modal open={showModalConfirm} onClose={onCancelModalConfirm}>
        <Modal.Header>
          <Modal.Title>
            <b>{modalConfirm.title ?? "Confirmar ação"}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalConfirm.message}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={onCancelModalConfirm}
            style={{
              background: "white",
              border: "1px solid #1F70B3",
              color: "#1F70B3",
            }}
          >
            Cancelar
          </Button>
          <Button
            style={{ marginLeft: ".5rem" }}
            onClick={onConfirmModalConfirm}
          >
            Continuar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        open={showModalMessage}
        onClose={() => {
          setShowModalMessage(false);
        }}
      >
        <Modal.Header>
          <Modal.Title>
            <b>{modalMessage.title ?? "Mensagem"}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage.message}</Modal.Body>
        <Modal.Footer>
          <Button
            style={{ marginLeft: ".5rem" }}
            onClick={() => {
              setShowModalMessage(false);
            }}
          >
            Continuar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

function useModals() {
  return ModalsData;
}

export { ModalsProvider, useModals };
